// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/pagination-data-schema',
  type: 'object',
  required: ['totalCount', 'pageSize', 'currentPage', 'totalPages'],
  properties: {
    totalCount: {
      type: 'integer',
    },
    pageSize: {
      type: 'integer',
    },
    currentPage: {
      type: 'integer',
    },
    totalPages: {
      type: 'integer',
    },
    previousPage: {
      type: 'boolean',
    },
    nextPage: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
